import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Button from '@/components/Button'
import { useTheme } from '@/lib/hooks'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

const PopupContainer = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 90%;
  max-height: 80%;
  width: 600px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
`

const PopupHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    font-size: 20px;
    color: #333;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: #f0f0f0;
  }
`

const ProductsList = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`

const ProductItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f8f8f8;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`

const ProductImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 15px;
`

const ProductInfo = styled.div`
  flex: 1;

  h4 {
    margin: 0 0 5px 0;
    font-size: 16px;
    color: #333;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #666;
  }
`

const ProductPrice = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.theme?.colors?.primary || '#000'};
`

const ProductsBrowser = ({ isOpen, onClose }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const { t } = useTranslation()
  const products = theme?.products || []

  const handleProductClick = (productId) => {
    onClose()
    navigate(`/product/${productId}`)
  }

  if (!isOpen) return null

  return (
    <Overlay onClick={onClose}>
      <PopupContainer onClick={(e) => e.stopPropagation()}>
        <PopupHeader>
          <h3>{t('browseProducts') || 'Browse Products'}</h3>
          <CloseButton onClick={onClose}>×</CloseButton>
        </PopupHeader>
        <ProductsList>
          {products.map((product) => (
            <ProductItem
              key={product.id}
              onClick={() => handleProductClick(product.id)}
            >
              <ProductImage src={product.imageUrl} alt={product.title} />
              <ProductInfo>
                <h4>{product.title}</h4>
                <p>ID: {product.id}</p>
              </ProductInfo>
              <ProductPrice theme={theme}>
                {theme?.currency}{product.price.toFixed(2)}
              </ProductPrice>
            </ProductItem>
          ))}
        </ProductsList>
      </PopupContainer>
    </Overlay>
  )
}

export default ProductsBrowser